import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  Table,
  Tooltip,
  OverlayTrigger,
  Button
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { festivalActions } from '../../../redux/actions/festival-action';
import { baseUrl } from 'helper/ApiCall';
import MessageCom from "layouts/Dashboard/Message";
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
var Modal = require('react-bootstrap-modal');
var moment = require("moment");

class FestivalMusicDirectorListPage extends Component{
	constructor(props){
		super(props);
		let AdminUserStorage = JSON.parse(localStorage.getItem('admin-user'));
		const { festivalId } = this.props.match.params;
		this.state = {
			festivalId : festivalId,
			submitted   : false,
			Title : 'Music Director list',
			addModalUser: false,
			addModalUserEdit: false,
			user:{ 
				username:'', 
				email: '', 
				name: '', 
				school_name:'',
				school:'',
				date: '',
				time:{
						hour: '', // Store hour
						minute: '', // Store minute
						meridiem: 'AM', // Store AM/PM
					},
				order: '' 
				//total_members:'' 
			},
			editUser:'',
			userError : {
			usernameError:'',
			emailError:'',
			nameError:'',
			school_nameError:'',
			schoolError:'',
			// total_membersError:''
			},
			users:{},
			AdminUserStorageToken : AdminUserStorage.token
		};
		this.openModalUser = this.openModalUser.bind(this);
		this.closeModalUser = this.closeModalUser.bind(this);
		this.saveAndCloseUser = this.saveAndCloseUser.bind(this);

		this.openModalUserEdit = this.openModalUserEdit.bind(this);
		this.closeModalUserEdit = this.closeModalUserEdit.bind(this);
		this.saveAndCloseUserEdit = this.saveAndCloseUserEdit.bind(this);


		this.handleUser = this.handleUser.bind(this);
		this.handleUserEdit = this.handleUserEdit.bind(this);
		this.handleUserSubmit = this.handleUserSubmit.bind(this);
		this.handleUserEditSubmit = this.handleUserEditSubmit.bind(this);
		this.validateAdd = this.validateAdd.bind(this);
		this.validateEdit = this.validateEdit.bind(this);

		this.clearField = this.clearField.bind(this);
		this.printMusicDirector = this.printMusicDirector.bind(this);
		this.deleteFestivalMusicDirector = this.deleteFestivalMusicDirector.bind(this);
		this.deleteFestivalConfirmMusicDirector = this.deleteFestivalConfirmMusicDirector.bind(this);
		this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
	};
  
	printMusicDirector(festivalId) {
		console.log('festivalId', festivalId);
	}
	deleteFestivalMusicDirector(festivalId, userId){
		const { dispatch } = this.props;
		dispatch(festivalActions.deleteFestivalMusicDirector(festivalId, userId));
	}

	deleteFestivalConfirmMusicDirector(festivalId, userId){
		confirmAlert({
			customUI: ({ onClose }) => {
			return (
				<div className='custom-ui'>
					<div className="react-confirm-alert-body">
						<h3>Delete Festival Music Director</h3>
						<p className="marginFromTopPopUp" >Are you sure to delete the festival music director?</p>
						<div className="react-confirm-alert-button-group">
							<button onClick={onClose}>No</button>
							<button onClick={() => {
								this.deleteFestivalMusicDirector(festivalId, userId)
								onClose()
							}}>Yes</button>
						</div>
					</div>
				</div>
			)
			}
		})
	}
	randomString(len, charSet) {
		// charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		charSet = charSet || 'ABCDEFGHJKMNPQRSTUVWXYZ23456788';
		var randomString = '';
		for (var i = 0; i < len; i++) {
			var randomPoz = Math.floor(Math.random() * charSet.length);
			randomString += charSet.substring(randomPoz,randomPoz+1);
		}
		return randomString;
	}
	clearField(){
		this.setState({user:{username:this.randomString(6), email:'', name:'' , school_name:'',  school:'',date: '',time: {hour: '',minute: '',meridiem: 'AM',}, order: ''  
			// total_members:''
		}});
		this.setState({userError:{usernameError:'', emailError:'', nameError:'' , school_nameError:'', schoolError:'', 
			// total_membersError:''
		}});
	}
	componentDidMount() {
		const { dispatch } = this.props;
		dispatch(festivalActions.getFestivalMusicDirectors(this.state.festivalId));
	}

	handleUserEditSubmit(e){
		e.preventDefault();
		this.setState({ submitted: true }, function(){
			const err = this.validateEdit();
			if (!err){

			console.log('this.props.editUser', this.props.editUser);
			const { dispatch } = this.props;
			dispatch(festivalActions.editFestivalMusicDirector(this.state.editUser, this.state.festivalId, this.props.editUser.id));
			}
		});
	}
	handleUser(e){
		const { name, value } = e.target;
		const userState = {...this.state.user};
		userState[name] = value;
		this.setState({user: userState}, function(){

		});
	}

	handleUserEdit(e) {
		console.log("handleUserEdit", e);

		if (e instanceof Date || e === null) {
			const userStateEdit = { ...this.state.editUser };

			// Format the date as "YYYY-MM-DD" and store it in state
			userStateEdit['date'] = e ? moment(e).format('YYYY-MM-DD') : null;
			this.setState({ editUser: userStateEdit });
		} else {
			const { name, value } = e.target;
			const userStateEdit = { ...this.state.editUser };
			userStateEdit[name] = value;
			this.setState({ editUser: userStateEdit });
		}
	}
	handleChangeStartDate(date){
		console.log('date', date);
		// const { name } = e.target;
		const userState = {...this.state.user};
		userState['date'] = date ? moment(date).format('YYYY-MM-DD') : null;
		this.setState({user: userState});
	}
  
	validateEdit(){
		let   isError = false;
		const errors = {
			usernameError:'',
			emailError:'',
			nameError:'',
			school_nameError:'',
			schoolError:'',
			//total_membersError:''
		};

		if (this.state.editUser.username.length === 0 || this.state.editUser.username.trim() === '') {
			isError = true;
			errors.usernameError = "Username is required.";
		}


		if (this.state.editUser.name.length === 0 || this.state.editUser.name.trim() === '') {
			isError = true;
			errors.nameError = "Name is required.";
		}


		if (this.state.editUser && this.state.editUser.email && this.state.editUser.email.length !== 0 && !(this.state.editUser.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ) {
			isError = true;
			errors.emailError = "Email is required & must be abc@example.com format.";
		}


		if ((this.state.editUser.school_name.length === 0 || this.state.editUser.school_name === '') ) {
			isError = true;
			errors.school_nameError = "Group Name is required.";
		}
		if ((this.state.editUser.school.length === 0 || this.state.editUser.school === '') ) {
			isError = true;
			errors.schoolError = "School Name is required.";
		}

		this.setState({userError: errors}, function(){
			// console.log('user validation',this.state.userError);
		});
		return isError; 
	}
	validateAdd(){
		let   isError = false;
		const errors = {
			usernameError:'',
			emailError:'',
			nameError:'',
			school_nameError:'',
			schoolError:'',
			//total_membersError:''
		};

		console.log('user validation',this.state.user);
		if (this.state.user.username.length === 0 || this.state.user.username.trim() === '') {
			isError = true;
			errors.usernameError = "Username is required.";
		}


		if (this.state.user.name.length === 0 || this.state.user.name.trim() === '') {
			isError = true;
			errors.nameError = "Name is required.";
		}


		if (this.state.user.email.length !== 0 && !(this.state.user.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ) {
			isError = true;
			errors.emailError = "Email is required & must be abc@example.com format.";
		}


		if ((this.state.user.school_name.length === 0 || this.state.user.school_name.trim() === '') ) {
			isError = true;
			errors.school_nameError = "Group Name is required.";
		}
		if ((this.state.user.school.length === 0 || this.state.user.school.trim() === '') ) {
			isError = true;
			errors.schoolError = "School Name is required.";
		}

		this.setState({userError: errors}, function(){
			// console.log('user validation',this.state.userError);
		});
		return isError; 
	}
	handleUserSubmit(e){
		e.preventDefault();
		this.setState({ submitted: true }, function(){
			const err = this.validateAdd();
			if (!err){
			const { dispatch } = this.props;
			console.log('this.state.user', this.state.user);
			dispatch(festivalActions.storeFestivalMusicDirector(this.state.user, this.state.festivalId));
			}
		});
	}
	closeModalUser(){
		this.clearField();
		this.setState({addModalUser:false});
	}
	saveAndCloseUser(){
		this.clearField();
		this.setState({addModalUser:false});
	}
	openModalUser(){
		this.clearField();
		this.setState({addModalUser:true});
	}

	closeModalUserEdit(){
		this.clearField();
		this.setState({addModalUserEdit:false});
	}
	saveAndCloseUserEdit(){
		this.clearField();
		this.setState({addModalUserEdit:false});
	}
	openModalUserEdit(id){
		this.clearField();
		const { dispatch } = this.props;
		dispatch(festivalActions.getFestivalMusicDirector(id));

	}

	componentWillReceiveProps(nextProps) {

		// console.log('nextProps', nextProps);
		if (nextProps.editUser && !nextProps.loading && nextProps.editCheck){
		const time = nextProps.editUser.time; // "HH:mm:ss"
		let timeObject = {
			hour: "",
			minute: "",
			meridiem: "AM",
		};

		if (time) {
			const [hour, minute] = time.split(":"); // Split "HH:mm:ss"
			const hourInt = parseInt(hour, 10);

			// Create the time object with 12-hour format and AM/PM
			timeObject = {
				hour: hourInt === 0 ? "12" : (hourInt > 12 ? hourInt - 12 : hourInt).toString().padStart(2, "0"),
				minute: minute.padStart(2, "0"),
				meridiem: hourInt >= 12 ? "PM" : "AM",
			};
		}
		this.setState({editUser:{
			username:nextProps.editUser.username,
			email:nextProps.editUser.email,
			name:nextProps.editUser.name,
			school_name:nextProps.editUser.school_name,
			school:nextProps.editUser.school,
			date:nextProps.editUser.date,
			time:timeObject,
			order:nextProps.editUser.order,
			// total_members: nextProps.editUser.total_members
		}}, function(){

			this.setState({addModalUserEdit:true});
		});
		}

		if (nextProps.users){

		this.setState({users:nextProps.users});
		}
		
	}
	
	handleTimeChange = (event) => {
		const timeValue = event.target.value; // e.g., "10:20"
		console.log("timeValue: ", timeValue);
	
		const targetKey = this.state.addModalUserEdit ? "editUser" : "user";
	
		// If the field is cleared (empty string), reset state
		if (!timeValue || timeValue.length < 5) { // Ensure it's a full time (HH:mm)
			this.setState((prevState) => ({
				[targetKey]: {
					...prevState[targetKey],
					time: { hour: "", minute: "", meridiem: "" }, // Fully reset time
				},
			}));
			return;
		}
	
		// Parse the time input
		const timeMoment = moment(timeValue, "HH:mm");
	
		let time = { hour: "", minute: "", meridiem: "" };
		if (timeMoment.isValid()) {
			time = {
				hour: timeMoment.format("hh"), // 12-hour format
				minute: timeMoment.format("mm"), // Minutes
				meridiem: timeMoment.format("A"), // AM/PM
			};
		}
	
		// Update state
		this.setState((prevState) => ({
			[targetKey]: {
				...prevState[targetKey],
				time,
			},
		}));
	};

	// Ensure the input shows "--:-- --" when time is empty
	getTimeForInput = () => {
		const targetKey = this.state.addModalUserEdit ? "editUser" : "user";
		const { time } = this.state[targetKey];
	
		// If any part of time is missing, return empty string
		if (!time || !time.hour || !time.minute || !time.meridiem) {
			return ""; // This will clear the input field
		}
	
		// Convert to 24-hour format for input field
		const hour24 =
			time.meridiem === "PM" && time.hour !== "12"
				? parseInt(time.hour, 10) + 12
				: time.hour === "12" && time.meridiem === "AM"
				? 0
				: time.hour;
	
		return `${hour24.toString().padStart(2, "0")}:${time.minute.padStart(2, "0")}`;
	};
	getFormattedDateTime = (input, format, isTimeOnly = false) => {
		if (!input) {
			console.error("Invalid input");
			return '';
		}
	
		// Handle time-only input
		if (isTimeOnly) {
			const [hour, minute, second] = input.split(':'); // Split "HH:mm:ss"
			const dateObject = moment()
				.set({ hour, minute, second }) // Set time directly on today's date
				.startOf('second'); // Avoid any fractional seconds
			return dateObject.format(format);
		}
	
		// Handle full datetime input
		const momentDate = moment(input, 'YYYY-MM-DD HH:mm:ss');
		if (!momentDate.isValid()) {
			console.error("Invalid date/time format");
			return '';
		}
		return momentDate.format(format);
	};
	
	
	
	 
  render(){
      const { user, userError, submitted } = this.state;
      const { users, adminType, festival  } = this.props;
	  const time = this.state.user.time || { hour: '', minute: '', meridiem: 'AM' };
        return(
          <div className="content">
            <Grid fluid>
                <Row>
                  <Col md={12}>
                      <Card
                        title="Festival Music Director List"

                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                              
                              

                              <Row>
                                <Col md={6} className="mb-20-test">
                                  {
                                    festival &&
                                      <h4 style={{'margin':'0px'}}> Festival Name: <strong>{festival.name}</strong></h4>
                                  }
                                </Col>
                                <Col md={6} className="text-right mb-20-test">
                                  <div >
                                    {
                                      adminType ==='company' && 
                                      <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add Music Director</Tooltip>}>
                                        <Button type='button' style={{marginRight:'5px'}} className="outOfTableButton btn btn-info" onClick={this.openModalUser} ><i className="fa fa-plus" />Music Director</Button>
                                      </OverlayTrigger>
                                    }
                                    {
                                      users && users.length > 0 &&
                                      <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Print Music Directors</Tooltip>}>
                                        <a href={baseUrl+'musicDirectors/print/'+this.state.festivalId+'?token='+this.state.AdminUserStorageToken} className="outOfTableButton btn btn-info"><i className="fa fa-print" />Print Music Directors</a>
                                      </OverlayTrigger>
                                    }
                                    
                                  </div>
                                </Col>
                              </Row>
                            </Grid>
                            
                            <div>
                            {/*Company Users Table Start*/}
                            { users && users.length > 0 &&
                              <Table striped hover className="myTable tableLayoutFix">
                                <thead>
                                  <tr>
                                    <th style={{width:"20%"}}>Name</th>
                                    <th style={{width:"10%", minWidth:"150px"}}>Username</th>
                                    <th style={{width:"30%"}}>Email</th>
                                    <th style={{width:"30%"}}>School Name</th>
                                    <th style={{width:"30%"}}>Group Name</th>
                                    <th style={{width:"10%"}} className="action-center">Date</th>
                                    <th style={{width:"10%"}} className="action-center">Time</th>
                                    <th style={{width:"10%"}} className="action-center">Order</th>
                                    <th style={{width:"20%", minWidth:"140px"}} className="action-center">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {users.map((prop, key) => {
                                    return (
                                      <tr key={key}>
                                        <td>{prop.name}</td>
                                        <td style={{minWidth:"250"}}>{prop.username}</td>
                                        <td>{prop.email}</td>
                                        <td>{prop.school}</td>
                                        <td>{prop.school_name}</td>
                                        <td>{prop.date ? this.getFormattedDateTime(prop.date, 'MM/DD/YY') : ''}</td>
										                    <td>{prop.time ? this.getFormattedDateTime(prop.time, 'hh:mm A', true) : ''}</td>
                                        <td className="action-center">{prop.order ? prop.order : ''}</td>
                                        { /*<td>{prop.total_members}</td>*/}
                                        <td className="action-center" style={{minWidth:"140px"}}>
                                          <div style={{minWidth:"125px"}}>
                                            {/*
                                              <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit User</Tooltip>}>
                                                <button type='button' className="action-button-size" ><i className="fa fa-pencil" /></button>
                                              </OverlayTrigger>
                                              <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete User</Tooltip>}>
                                                <button type='button' className="action-button-size" ><i className="fa fa-trash " /></button>
                                              </OverlayTrigger>
                                            */}
                                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Music Director {adminType ==='company'?'edit':'view'}</Tooltip>}>
                                              <button type='button' className="action-button-size" onClick={() => this.openModalUserEdit(prop.id)}><i className={adminType ==='company'?"fa fa-pencil":"fa fa-eye"} /></button>
                                            </OverlayTrigger>
                                            {
                                              adminType ==='company' && 
                                              <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete Music Director</Tooltip>}>
                                                <button type='button' className="action-button-size" onClick={() => this.deleteFestivalConfirmMusicDirector(prop.festival_id, prop.id)}><i className="fa fa-trash " /></button>
                                              </OverlayTrigger>
                                            }
                                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Music Director Festival Performance</Tooltip>}>
                                              <Link to={'/Admin/MD-media/'+prop.id} className="action-button-size"><i className="fa fa-youtube-play" /></Link>
                                            </OverlayTrigger>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}

                                 
                                </tbody>
                              </Table>
                            }
                            </div>
                            {
                              users && users.length === 0 &&

                              <Grid fluid>
                                <Row>
                                    <Col md={8}>
                                      <h4>No Company User Found</h4>
                                    </Col>
                                </Row>
                              </Grid>
                              
                            }
                            
                            {/*Company Users Table End*/}

                            {/* Add User*/}
                            

                            {/*Edit User Modal start*/}
                            { this.state.addModalUserEdit && 
                              <Modal show={this.state.addModalUserEdit} onHide={this.closeModalUserEdit} dialogClassName="director_form_modal" aria-labelledby="ModalHeader" >
                              <Modal.Header closeButton>
                                <Modal.Title id='ModalHeader'>Music Director {adminType ==='company'?'Edit':''}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="row">
                                  <div className="col-md-12">
                                    <form onSubmit={this.handleUserEditSubmit}>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.nameError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="name">Name
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip_name">You have a maximum # of 100 characters</Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                            </label>
                                            <input type="text" name="name" className="form-control"  value={this.state.editUser.name} onChange={this.handleUserEdit} maxLength="100" />
                                            {
                                              submitted && userError.nameError!=='' &&
                                              <div className="help-block">{userError.nameError}</div>
                                            }
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.usernameError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="username">Username</label>
                                            <input type="text" name="username" className="form-control"  maxLength="6" minLength="6" value={this.state.editUser.username} onChange={this.handleUserEdit} />
                                            {
                                              submitted && userError.usernameError!=='' &&
                                              <div className="help-block">{userError.usernameError}</div>
                                            }
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.emailError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="email">Email</label>
                                            <input type="text" name="email" className="form-control" value={this.state.editUser.email} onChange={this.handleUserEdit} />
                                            {
                                              submitted && userError.emailError!=='' &&
                                              <div className="help-block">{userError.emailError}</div>
                                            }
                                          </div>
                                        </div>
                                        {/* School Name */}
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.schoolError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="school">School Name
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip_school">You have a maximum # of 100 characters</Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                            </label>
                                            <input type="text" name="school" className="form-control"  value={this.state.editUser.school} onChange={this.handleUserEdit} maxLength="100" /> {
                                              submitted && userError.schoolError!=='' &&
                                              <div className="help-block">{userError.schoolError}</div>
                                            }
                                          </div>
                                        </div>
                                      </div>

                                      

                                      <div className="row">
                                        {/* Date */}
                                        <div className="col-md-3">
                                              <div className={'dateSelector form-group'}>
                                                <label htmlFor="state">Date</label>
                                                <DatePicker 
                                                ref="date" 
                                                name="date"
                                                className="form-control calender_icon" 
                                                selected={
                                                    this.state.editUser.date
                                                    ? new Date(this.state.editUser.date) // Convert to Date object
                                                    : null // Pass null if no date is selected
                                                  } 
                                                onChange={this.handleUserEdit}/>
                                              </div>
                                        </div>
                                        {/* Time */}
                                        <div className="col-md-3">
                                            <div className={'form-group'}>
                                              <label htmlFor="time">Time</label>
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip">
                                                  If you leave the date/time blank, the schools will be presented on the app in alphabetical order. You can add the date/time of performance, or the order in which they will appear.
                                                </Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                              <input
                                                id="time"
                                                type="time"
                                                className='form-control'
                                                readOnly={this.state.editUser.order ? true : false}
                                                value={this.getTimeForInput()} // Set the value from state in 24-hour format
                                                onChange={this.handleTimeChange} // Handle changes
												onKeyDown={this.handleKeyDown}
												key={this.getTimeForInput()}
                                              />
                                            </div>
                                        </div>
                                        {/* Group Name */}
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.school_nameError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="school_name">Group Name 
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip_group_name">You have a maximum # of 100 characters</Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                            </label>
                                            <input type="text" name="school_name" className="form-control"  value={this.state.editUser.school_name} onChange={this.handleUserEdit} maxLength="100" /> {
                                              submitted && userError.school_nameError!=='' &&
                                              <div className="help-block">{userError.school_nameError}</div>
                                            }
                                          </div>
                                        </div>
                                      </div>

                                      {
                                        /*
                                        <div className="row">
                                          <div className="col-md-6">
                                            <div className={'form-group' + (submitted && userError.total_membersError!=='' ? ' has-error' : '')}>
                                              <label htmlFor="total_members">Total Students</label>
                                              <input type="number" min={0} step={1} name="total_members" className="form-control"  value={this.state.editUser.total_members} onChange={this.handleUserEdit} readOnly={adminType ==='admin'?true:false}/>
                                              {
                                                submitted && userError.total_membersError!=='' &&
                                                <div className="help-block">{userError.total_membersError}</div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                        */
                                      }
                                      {
                                        <div className="row">
                                          <div className="col-md-3">
                                            <div className={'form-group'}>
                                              <label htmlFor="order">Order</label>
                                              <input type="text" name="order" disabled={this.state.editUser.time.hour ? true : false} className="form-control"  value={this.state.editUser.order} onChange={this.handleUserEdit}/>
                                            </div>
                                          </div>

                                        </div>
                                      }
                                      
                                      {
                                        adminType === 'company' &&
                                        <div className="row">
                                          <div className="col-md-4">
                                            <div className='btn-toolbar'>
                                              <Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton " >Save</Button>
                                              <Button bsSize="large" bsStyle="info" onClick={()=>this.closeModalUserEdit() } className="outOfTableButton" >Cancel</Button>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      <div className="row">
                                        <div className="col-md-12">
                                          <div>
                                            <MessageCom  />
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                  
                                </div>
                              </Modal.Body>
                              </Modal>
                            }
                            {/*Edit User Modal End*/}

                            {/*Add User Modal Start*/}
                            <Modal show={this.state.addModalUser} onHide={this.closeModalUser} dialogClassName="director_form_modal" aria-labelledby="ModalHeader" >
                              <Modal.Header closeButton>
                                <Modal.Title id='ModalHeader'>Add Music Director</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                              <div className="row">
                                <div className="col-md-12">
                                  <form onSubmit={this.handleUserSubmit}>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.nameError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="name">Name
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip_name">You have a maximum # of 100 characters</Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                            </label>
                                          <input type="text" name="name" className="form-control"  value={user.name} onChange={this.handleUser} maxLength="100" />
                                          {
                                            submitted && userError.nameError!=='' &&
                                            <div className="help-block">{userError.nameError}</div>
                                          }
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.usernameError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="username">Username</label>
                                          <input type="text" name="username" className="form-control" maxLength="6" minLength="6" value={user.username} onChange={this.handleUser}/>
                                          {
                                            submitted && userError.usernameError!=='' &&
                                            <div className="help-block">{userError.usernameError}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.emailError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="email">Email</label>
                                          <input type="text" name="email" className="form-control" value={user.email} onChange={this.handleUser} />
                                          {
                                            submitted && userError.emailError!=='' &&
                                            <div className="help-block">{userError.emailError}</div>
                                          }
                                        </div>
                                      </div>
                                      {/* School */}
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.schoolError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="school">School Name 
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip_school">You have a maximum # of 100 characters</Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                            </label>
                                          <input type="text" name="school" className="form-control"  value={user.school} onChange={this.handleUser} maxLength="100" />
                                          {
                                            submitted && userError.schoolError!=='' &&
                                            <div className="help-block">{userError.schoolError}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    {
                                      /*
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.total_membersError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="total_members">Total Students</label>
                                            <input type="number" min={0} step={1} name="total_members" className="form-control"  value={user.total_members} onChange={this.handleUser}/>
                                            {
                                              submitted && userError.total_membersError!=='' &&
                                              <div className="help-block">{userError.total_membersError}</div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      */
                                    }

                                    <div className="row">
                                      {/* Date */}
                                      <div className="col-md-3">
                                        <div className={'dateSelector form-group'}>
                                        <label htmlFor="state">Date</label>
                                          <DatePicker ref="date" className="form-control calender_icon" selected={user.date ? new Date(user.date) : null} onChange={this.handleChangeStartDate} readOnly={(adminType ==='admin') ? true : false}/>
                                          
                                        </div>
                                      </div>
                                      {/* Time */}
                                      <div className="col-md-3">
                                        <div className={'form-group'}>
                                          <label htmlFor="time">Time</label>
                                          <OverlayTrigger placement="bottom" overlay={
                                            <Tooltip id="tooltip">
                                              If you leave the date/time blank, the schools will be presented on the app in alphabetical order. You can add the date/time of performance, or the order in which they will appear.
                                            </Tooltip>}>
                                            <span className="question_mark user_comment">?</span>
                                          </OverlayTrigger>
                                          <input
                                            id="time"
                                            type="time"
                                            className='form-control'
                                            readOnly={user.order ? true : false}
                                            value={this.getTimeForInput()} // Set the value from state in 24-hour format
                                            onChange={this.handleTimeChange} // Handle changes
											key={this.getTimeForInput()}
											placeholder="--:-- --"
											
                                          />
                                        </div>
                                      </div>
                                      {/* Group Name */}
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.school_nameError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="school_name">Group Name 
                                              <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id="tooltip_school_name">You have a maximum # of 100 characters</Tooltip>}>
                                                <span className="question_mark user_comment">?</span>
                                              </OverlayTrigger>
                                            </label>
                                          <input type="text" name="school_name" className="form-control"  value={user.school_name} onChange={this.handleUser} maxLength="100" />
                                          {
                                            submitted && userError.school_nameError!=='' &&
                                            <div className="help-block">{userError.school_nameError}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      {/* Order */}
                                      <div className="col-md-3">
                                        <div className={'form-group'}>
                                          <label htmlFor="order">Order</label>
                                          <input type="text" disabled={user.time.hour ? true : false} name="order" className="form-control"  value={user.order} onChange={this.handleUser}/>
                                          {
                                            submitted && userError.orderError!=='' &&
                                            <div className="help-block">{userError.orderError}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className='btn-toolbar'>
                                          <Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton" >Save</Button>
                                          <Button bsSize="large" bsStyle="info" onClick={()=>this.closeModalUser() } className="outOfTableButton" >Cancel</Button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-12">
                                        <div>
                                          <MessageCom  />
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                                
                                </div>
                              </Modal.Body>
                            </Modal>
                            {/*Add User Modal End*/}
                          </div>
                        }
                    />
                  </Col>
                </Row>
              </Grid>
          </div>
        );
  }
}


function mapStateToProps(state) {
    const { loading, editUser, users, festival, editCheck } = state.festivalReducer;
    console.log('music director users', users);
    const { adminType, userAdmin } = state.adminReducer;
    return {
        loading, editUser, users, adminType, userAdmin, festival, editCheck
    };
}

const FestivalMusicDirectorList = connect(mapStateToProps)(FestivalMusicDirectorListPage);
export default FestivalMusicDirectorList;


// WEBPACK FOOTER //
// ./src/components/Admin/FestivalMusicDirector/FestivalMusicDirectorList.jsx